import "./App.css";
import {
  createBrowserRouter,
  createRoutesFromElements,
  Route,
  RouterProvider,
} from "react-router-dom";

import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import PrivateRoute from "./routes/PrivateRoute";
import PublicRoute from "./routes/PublicRoute";
import AdminRoute from "./routes/AdminRoute";
import LoginFormComponent from "./components/auth/LoginFormComponent";
import DevtoolGuard from "./DevtoolGuard";

// Layout and Pages
import MainLayout from "./components/layout/MainLayout";
import Dashboard from "./components/pages/Dashboard";
import AdminLayout from "./components/admin/AdminLayout";
import UserManagementPage from "./components/admin/UserManagementPage";
import SharedConversation from "./components/pages/SharedConversation";

const router = createBrowserRouter(
  createRoutesFromElements(
    <Route>
      {/* Private Routes - Authenticated users */}
      <Route element={<PrivateRoute />}>
        <Route element={<MainLayout />}>
          <Route path="/chatbot-ai" element={<Dashboard />} />
          <Route path="/" element={<Dashboard />} />
          <Route path="/chatbot-ai/:id" element={<Dashboard />} />
        </Route>
      </Route>
      {/* Admin Routes - Admin / CTV only */}
      <Route element={<AdminRoute />}>
        <Route element={<AdminLayout />}>
          <Route path="/admin-chatbot-ai" element={<UserManagementPage />} />
          <Route
            path="/admin-chatbot-ai/users"
            element={<UserManagementPage />}
          />
        </Route>
      </Route>
      {/* Public share page — không cần login */}
      <Route path="/share/:shareId" element={<SharedConversation />} />
      {/* Public Routes - Non-authenticated users */}{" "}
      <Route element={<PublicRoute />}>
        <Route path="/login" element={<LoginFormComponent />} />
      </Route>
    </Route>,
  ),
);
function App() {
  return (
    <div className="App h-full">
      <DevtoolGuard />
      <RouterProvider router={router} />
      <ToastContainer
        position="top-right"
        autoClose={5000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
        theme="light"
      />
    </div>
  );
}

export default App;
